import "./Portfolio.css";
import { Data } from "./Data.js";

const Portfolio = () => {
    return (
        <section className="portfolio section" id="portfolio">
            <h2 className="section__title">Portfolio</h2>
            <span className="section__subtitle">Most Recent Work!</span>

            <div className="portfolio__container container grid">
                {Data.map((elem, i) => {
                    const { image, link, title, subtitle, tech } = elem;

                    return (
                        <div className="portfolio__content" key={i}>
                            <img src={image} className="img__portfolio" alt={title} />
                            <h2 className="title__portfolio">{title}</h2>
                            <p className="subtitle__portfolio">{subtitle}</p>

                            <div className="tech__icons">
                                {tech.map((icon, i) => (
                                    <span className="tech__icon" key={i}>
                                    {icon}
                                    </span>
                                ))}
                            </div>
                            <a href={link} target="_blank" className="link__portfolio" rel="noreferrer">
                                Demo <i className="uil uil-arrow-right"></i>
                            </a>
                        </div>
                    );
                })}
            </div>
        </section>
    )
}

export default Portfolio